import { actionWithDatapoint } from 'owa-analytics-actions';
import { action } from 'satcheljs';

import getEntryPoint from '../selectors/getEntryPoint';
import getFirstTimeUser from '../selectors/getFirstTimeUser';
import { getUserMailboxGuid } from '../utils/getMailboxGuid';

/**
 * Action to set the promise that returns theme image Id.
 */
export const setCurrentEventThemeImageIdPromise = action(
    'setCurrentEventThemeImageIdPromise',
    (themeImageIdPromise: Promise<string | null>) => ({ themeImageIdPromise })
);

/**
 * Action to update the themeImage of the currentEvent
 */

export const updateCurrentEventThemeImageAction = actionWithDatapoint(
    'updateCurrentEventThemeImageAction',
    (imageEnum: number) => ({
        imageEnum,
    }),
    (actionMessage: { imageEnum: number }) => ({
        customData: {
            imageEnum: actionMessage.imageEnum,
            entryPoint: getEntryPoint(),
            isNewUser: getFirstTimeUser(),
            mailboxGuid: getUserMailboxGuid(),
        },
    })
);

/**
 * Action to update the selected emoji of the current event
 */
export const updateCurrentEventEmojiAction = action(
    'updateCurrentEventEmojiAction',
    (emojiCode: string) => ({
        emojiCode,
    })
);
